import React from 'react';
import { Logo } from './Logo';
export function Footer() {
  return <footer className="bg-[#111827] py-12" data-id="element-55">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col items-center" data-id="element-56">
        <a href="#plano" className="mb-6" data-id="element-57">
          <Logo showText={true} size="md" variant="light" data-id="element-58" />
        </a>
        <p className="text-gray-400 text-sm text-center" data-id="element-59">
          © 2026 Obra Digital. Todos los derechos reservados.
        </p>
        <div className="mt-4 flex items-center gap-4" data-id="element-60">
          <a href="#brand" className="text-gray-600 text-xs hover:text-gray-400 transition-colors" data-id="element-61">
            Brand
          </a>
          <span className="text-gray-700 text-xs" data-id="element-62">·</span>
          <a href="#plano" className="text-gray-600 text-xs hover:text-gray-400 transition-colors" data-id="element-63">
            Plano
          </a>
          <span className="text-gray-700 text-xs" data-id="element-64">·</span>
          <a href="#pinfotos" className="text-gray-600 text-xs hover:text-gray-400 transition-colors" data-id="element-65">
            Pin Fotos
          </a>
        </div>
      </div>
    </footer>;
}